<template>
  <div class="popup-full">
    <div class="popup-full__wrap">
      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__media">
            <picture class="popup-full__img">
              <img src="../assets/img/popup/back-to-vacancy.svg"
                   :alt="$tInteraction('Switch to individual mode?')">
            </picture>
          </div>

          <h3 class="popup-full__title">{{ $tInteraction('Switch to individual mode?') }}</h3>
          <div class="popup-full__text text">
            <p>{{
                $tInteraction('Switch to individual mode description')
              }}</p>
          </div>

          <BaseAlert :value="error"
                     class="popup-full__error  _warning"/>

          <div class="popup-full__buttons">
            <button type="button"
                    @click.prevent="onSwitch"
                    class="popup-full__btn  base-btn  base-btn--green">
              <span class="base-btn__text">
                {{ $tInteraction('Switch to individual mode') }}
              </span>
              <BasePreloader v-if="pending" class="_small"/>
            </button>
            <button type="button"
                    @click.prevent="close"
                    class="popup-full__btn  base-btn  base-btn--outline-dark">
              <span class="base-btn__text">
                {{ $tInteraction('Close') }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from "@/axios"
  import handleError from "@/helpers/handleError"

  export default {
    name: 'ModalToCustomInteraction',
    props: {
      iterationId: Number
    },
    data() {
      return {
        pending: false,
        error: false,
      }
    },
    computed: {},
    methods: {
      onSwitch() {
        this.error = null
        this.pending = true

        const sendData = {
          interaction_id: this.iterationId,
          employment_type: 4
        }

        http.post(`api/new-interaction/set-employment-type`, sendData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction', this.iterationId)
          this.close()
        }).catch(e => {
          this.error = handleError(e)
        }).finally(() => {
          this.pending = false
        })
      },
      close() {
        this.$vModal.close('to-custom-interaction')
      }
    },
  }
</script>

<style lang="less">

</style>